import { render, staticRenderFns } from "./AnimalSubscribe.vue?vue&type=template&id=48821174&scoped=true&"
import script from "./AnimalSubscribe.vue?vue&type=script&lang=ts&"
export * from "./AnimalSubscribe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48821174",
  null
  
)

export default component.exports